import { TabsComponent } from '@noorden-insurtech/alba-design-system';
import { useState } from 'react';
import { CommissionStatementTab } from './commission-statement-tab.component';
import { MyReceiptsTab } from './my-receipts-tab.component';

export function FinancialPage() {
  const [activeTab, setActiveTab] = useState<string>('receipts');

  return (
    <TabsComponent.Root
      value={activeTab}
      onValueChange={details => setActiveTab(details.value)}
    >
      <TabsComponent.List className='grid grid-cols-2'>
        <TabsComponent.Trigger value='receipts'>
          Meus Recibos
        </TabsComponent.Trigger>
        <TabsComponent.Trigger value='statement'>
          Demonstrativo de Comissão
        </TabsComponent.Trigger>
      </TabsComponent.List>

      <TabsComponent.Content value='receipts'>
        <MyReceiptsTab />
      </TabsComponent.Content>

      <TabsComponent.Content value='statement'>
        <CommissionStatementTab />
      </TabsComponent.Content>
    </TabsComponent.Root>
  );
}
